
import React, {FC} from 'react';
import CanvasComposite from 'templates/reports/Section/ScanImages/CanvasComposite';
import CanvasSingle from 'templates/reports/Section/ScanImages/CanvasSingle';
import Colorable from 'templates/reports/Section/ScanImages/Colorable';
import SaveImage from 'templates/reports/Section/ScanImages/SaveImage';
import {Colors} from 'templates/reports/Section/ScanImages/useColors';
import {Images} from 'templates/reports/Section/ScanImages/useImages/query';
import {sortkey} from 'utils/sort';

import * as styles from './styles.module.scss';

type SelectedProps = {
	selected: Images
	colors: Colors
}

const Selected: FC<SelectedProps> = ({selected, colors: {config, counter}}) => {
	const images = selected.images
		.map((image) => ({
			image,
			cfg: config(image.type),
		}))
		.filter(({cfg}) => !!cfg)
		.sort(sortkey(({cfg}) => cfg?.order));

	return (
		<div className={styles.selected}>
			<SaveImage key={selected.start.unix} title='Composite'>
				{(canvas) => (
					<CanvasComposite
						canvas={canvas}
						images={images.map(({image}) => image)}
						config={config}
						key={counter}
					/>
				)}
			</SaveImage>
			{images.map(({cfg, image}) => cfg && (
				<Colorable key={`${selected.start.unix}:${image.type}`} config={cfg}>
					<SaveImage title={cfg.title}>
						{(canvas) => (
							<CanvasSingle
								canvas={canvas}
								image={image}
								config={cfg}
							/>
						)}
					</SaveImage>
				</Colorable>
			))}
		</div>
	);
};

export default Selected;
